// External Imports
import { h } from 'preact';
import { BodyText, Stack, Title, pxToRem, styled } from '@lessonnine/design-system.lib';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

// Local Variables
const cardTextAlign = { medium: 'left', small: 'center' };
const mobileBreakpoint = parseInt(tokens.viewports.breakpoints.small, 10);
const StyledStack = styled(Stack)`
  max-width: ${pxToRem(343)};
  padding: 0 16px;
  @media (min-width: ${pxToRem(mobileBreakpoint)}) {
    max-width: ${pxToRem(350)};
    width: 100%;
  }
`;

const ImageWithRadius = styled.img`
  border-radius: ${tokens.size.radius.large};
`;

function ValuePropCard({ image, title, body }) {
  return (
    <StyledStack gap={20}>
      <ImageWithRadius alt="" aria-hidden="true" src={image} />
      <Stack gap={8}>
        <Title as="div" size="xsmall" textAlign={cardTextAlign}>
          {title}
        </Title>
        <BodyText size={{ medium: 'default', small: 'small' }} textAlign={cardTextAlign}>
          {body}
        </BodyText>
      </Stack>
    </StyledStack>
  );
}

export { ValuePropCard };
